import { jSith } from "../jquery-replacement";
import { S25String } from "./s25.string";
import { S25Array } from "./s25.array";

export namespace S25Jquery {
    export function initEvents(targets: any, events: any, actionFn: any): any {
        _createEvents("on", targets, events, actionFn);
    }

    export function destroyEvents(targets: any, events: any, actionFn: any): any {
        _createEvents("off", targets, events, actionFn);
    }

    export function _createEvents(type: string, targets: any, events: any, actionFn: any): any {
        // events=false - special for qtip
        if (!targets || !events || !actionFn) {
            return;
        }

        // because replace above might introduced duplicates - get unique array of strings of events
        const eventsArr: any[] = typeof events === "string" ? S25Array.unique(S25String.split(events, " ")) : events;

        jSith.forEach(targets, function (_: any, target: any) {
            target = jSith.element(target);
            jSith.forEach(eventsArr, function (_: any, event: any) {
                if (event === "enter" || event === "space") {
                    event = "keypress";
                    const origActionFn = actionFn;
                    actionFn = function (e: any) {
                        const keyCode: number = e && parseInt(e.keyCode || e.which);
                        if (keyCode === 13 || keyCode === 32) {
                            e.preventDefault();
                            return origActionFn();
                        }
                    };
                }

                if (type === "on") {
                    window.angBridge.element(target).on(event, actionFn);
                } else {
                    window.angBridge.element(target).off(event, actionFn);
                }
            });
        });
    }
}
